export default {
	'total-benefit-for-kg': 'Beneficios totales por 1kg',
	accept: 'Aceptar',
	reject: 'Rechazar',
	'confirm-acceptance': 'Confirmar aceptación',
	'losing-purchase-alert': 'Esta simulación muestra que la oferta está perdiendo.\n¿Estás seguro de que deseas aceptarla?',
}